<!-- <h2>Steps</h2> -->
<div class="steps-card">
  <div id="ppl-steps" class="steps-head">
    <nz-steps [nzCurrent]="currentStep" nzDirection="vertical" class="main-steps">
      @if(getSteps('participant_info')?.isAvailable === "Y"){
      <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('participant_info')?.step_name" [nzStatus]="getStepStatus('participant_info', stepRef)" [attr.aria-label]="getSteps('participant_info')?.step_name + getStepStatus('participant_info')"
        (click)="goToStep('participant_info')" (selected)="goToStep('participant_info')" (keyboardSelected)="onStepKeyboardSelect($event, 'participant_info')"></nz-step>
      }
      @if(getSteps('service_details')?.isAvailable === "Y"){
      <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('service_details')?.step_name" [nzStatus]="getStepStatus('service_details', stepRef)"
        (click)="goToStep('service_details')" (selected)="goToStep('service_details')" (keyboardSelected)="onStepKeyboardSelect($event, 'service_details')"></nz-step>
      }
      @if(getSteps('contact_details')?.isAvailable === "Y"){
      <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('contact_details')?.step_name" [nzStatus]="getStepStatus('contact_details', stepRef)"
        (click)="goToStep('contact_details')" (selected)="goToStep('contact_details')" (keyboardSelected)="onStepKeyboardSelect($event, 'contact_details')"></nz-step>
      }
      @if(getSteps('comm_preferences')?.isAvailable === "Y"){
      <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('comm_preferences')?.step_name" [nzStatus]="getStepStatus('comm_preferences', stepRef)"
        (click)="goToStep('comm_preferences')" (selected)="goToStep('comm_preferences')" (keyboardSelected)="onStepKeyboardSelect($event, 'comm_preferences')"></nz-step>
      }
      @if(getSteps('associations')?.isAvailable === "Y"){
        <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('associations')?.step_name" [nzStatus]="getStepStatus('associations', stepRef)"
          (click)="goToStep('associations')" (selected)="goToStep('associations')" (keyboardSelected)="onStepKeyboardSelect($event, 'associations')"></nz-step>
      }
      @if(getSteps('signatures')?.isAvailable === "Y"){
        <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('signatures')?.step_name" [nzStatus]="getStepStatus('signatures', stepRef)"
          (click)="goToStep('signatures')" (selected)="goToStep('signatures')" (keyboardSelected)="onStepKeyboardSelect($event, 'signatures')"></nz-step>
      }
      @if(getSteps('forms')?.isAvailable === "Y"){
        <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('forms')?.step_name" [nzStatus]="getStepStatus('forms', stepRef)"
          (click)="goToStep('forms')" (selected)="goToStep('forms')" (keyboardSelected)="onStepKeyboardSelect($event, 'forms')"></nz-step>
      }
      @if(getSteps('checklist')?.isAvailable === "Y"){
        <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('checklist')?.step_name" [nzStatus]="getStepStatus('checklist', stepRef)"
          (click)="goToStep('checklist')" (selected)="goToStep('checklist')" (keyboardSelected)="onStepKeyboardSelect($event, 'checklist')"></nz-step>
      }
      @if(getSteps('upload_docs')?.isAvailable === "Y"){
      <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('upload_docs')?.step_name" [nzStatus]="getStepStatus('upload_docs', stepRef)"
        (click)="goToStep('upload_docs')" (selected)="goToStep('upload_docs')" (keyboardSelected)="onStepKeyboardSelect($event, 'upload_docs')"></nz-step>
      }
      @if(getSteps('payment_details')?.isAvailable === "Y"){
      <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('payment_details')?.step_name" [nzStatus]="getStepStatus('payment_details', stepRef)"
        (click)="goToStep('payment_details')" (selected)="goToStep('payment_details')" (keyboardSelected)="onStepKeyboardSelect($event, 'payment_details')"></nz-step>
      }
      @if(getSteps('summary')?.isAvailable === "Y"){
      <nz-step #stepRef pplKeyboardSelect [nzTitle]="getSteps('summary')?.step_name" [nzStatus]="getStepStatus('summary', stepRef)"
        (click)="goToStep('summary')" (selected)="goToStep('summary')" (keyboardSelected)="onStepKeyboardSelect($event, 'summary')"></nz-step>
      }
    </nz-steps>
  </div>
  <div #footerButtons class="steps-footer">
    <p class="steps-tips">
      <i class="fa fa-info-circle" aria-hidden="true"></i> Once you have completed a section you can go back to view or
      edit from here. Fields marked with an <span style="color: red;" [attr.aria-label]="'Required'">*</span> are required to move on to the next
      section.
    </p>

  @if(!isFormValid() && onSummary){
    <p><strong>Please ensure all mandatory steps are filled out before submitting.</strong></p>
  }
    @if(currentStep>0) {
    <ppl-button label="Previous" icon="fa fa-chevron-left" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="prev()"></ppl-button>
    }
    @if(!onSummary) {
      @if(flow === 'participantEnrollment' || flow === 'providerEnrollment' || flow === 'referral'){
        <ppl-button label="Save and Next" icon="fa fa-chevron-right" [customClass]="'alt-button'" [iconPosition]="'right'"
        (click)="next()"></ppl-button>
      }
      @else{
        <ppl-button label="Next" icon="fa fa-chevron-right" [customClass]="'alt-button'" [iconPosition]="'right'"
        (click)="next()"></ppl-button>
      }
    }
    @else {
    @if(flow === 'referral') {
    <!-- Commented out: standalone "Submit" (SAVE) button, kept only "Submit and Approve" renamed to "Submit" below. Revert by uncommenting this and removing the label override on the button below.
    <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
      [disabled]="!isFormValid()" (click)="submit('SAVE')"></ppl-button>
    -->
    <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
      [disabled]="!isFormValid()" (click)="submit('SUBMIT_APPROVE')"></ppl-button>
    }
    @else {
    <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
      [disabled]="!isFormValid()" (click)="submit()"></ppl-button>
    }
    }
  </div>
</div>